import constate from 'constate';
import { useReducer } from 'react';
import assign from 'lodash/assign';
import createReducer from 'helpers/reducers-helper';

export const SET_LICENSE_PLATES_DIALOG = 'SET_LICENSE_PLATES_DIALOG';
export const SET_CREDIT_CARD_DIALOG = 'SET_CREDIT_CARD_DIALOG';

export const useMain = () => {
  const initState = {
    setDistributorMessage: false,
    distributorMessageState: false,
    distributorMessageText: '',
    setLicensePlatesDialog: false,
    setCreditCardDialog: false,
    oilPricing: null,
  };

  const setLicensePlatesDialog = (state, payload) => assign({}, state, { setLicensePlatesDialog: payload });
  const setCreditCardDialog = (state, payload) => assign({}, state, { setCreditCardDialog: payload });

  const reducer = createReducer(
    {
      [SET_LICENSE_PLATES_DIALOG]: setLicensePlatesDialog,
      [SET_CREDIT_CARD_DIALOG]: setCreditCardDialog,
    },
    initState,
    true
  );

  const [state, dispatch] = useReducer(reducer, initState);

  return { state, dispatch };
};

const [MainProvider, useMainContext] = constate(useMain);

export { MainProvider, useMainContext };
